import type { FaireProductEntity } from "../../entity_types/product";

export const p_vqdhuyqq88: FaireProductEntity = {
  token: "p_vqdhuyqq88",
  type: "product",
  name: "Children's Rolling Stones Razorbacks Tie Dye Lick Sweatshirt",
  brandToken: "b_1bf5q9xdtj",
  brandName: "LivyLu",
  imageUrl:
    "https://cdn.faire.com/fastly/80636517a58c752d89041fe5d2173bb9111e040b5503a63e08656533f92e4136.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/569414f037a301585d7c68052119c4e8b2f4352298370876ad4048cb97e5072c.jpeg",
    "https://cdn.faire.com/fastly/878c4db9e159e39b5c5765e962ec67712858cefe6a7a3a6abd3929dd66d9727d.jpeg",
  ],
  priceDollars: 10,
  description:
    "Wooo Pig Sooie!!!  Show off your University of Arkansas Razorbacks Hog Spirit with this sweatshirt that is perfect for Game Day or Any Day! \n\nOfficially Licensed\nUnisex Children's Fit ",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:21.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
